export const UPDATE_EXTENSION = "UPDATE_EXTENSION";
